import {
  LANG_AVAILABLE,
  LANG_DEFAULT,
  LANG_PL,
  LANG_EN,
  LANG_PL_CODES
} from 'common/consts/language-code';
import { ANCHOR } from 'common/consts/common';

const localStorageItemKey = 'userLanguagePreference';
const botPattern = /(baiduspider|facebookexternalhit|twitterbot|googlebot|rogerbot|linkedinbot|embedly|quora link preview|showyoubot|outbrain|pinterest|slackbot|vkShare|W3C_Validator)/;

class Language {
  lang = this.requestCameFromBrowser()
    ? this.setLanguageForBrowser()
    : LANG_DEFAULT;

  setLanguageForBrowser() {
    this.checkLanguageFromPath();
    return this.getLocalStorageItem() || this.checkBrowserLanguage();
  }

  checkLanguageFromPath() {
    const lang = window.location.pathname.split('/')[1];

    if (this.isVaild(lang)) {
      this.setLocalStorageItem(lang);
    }
  }

  checkBrowserLanguage() {
    const PL_CODES = [LANG_PL, ...LANG_PL_CODES];
    const browserCode =
      window.navigator.userLanguage || window.navigator.language;

    const isPolishBrowser = PL_CODES.some(code => code === browserCode);

    return isPolishBrowser ? LANG_PL : LANG_EN;
  }

  requestCameFromBrowser() {
    return !botPattern.test(navigator.userAgent);
  }

  isVaild(lang) {
    return LANG_AVAILABLE.includes(lang);
  }

  isDefault(lang = this.lang) {
    return lang === LANG_DEFAULT;
  }

  getLang() {
    return this.lang;
  }

  setLang(lang) {
    if (!this.isActive(lang)) {
      this.lang = lang;
    }
  }

  getLangPrefix(lang = this.lang) {
    return lang === LANG_DEFAULT ? '' : `/${lang}`;
  }

  setLocalStorageItem(lang) {
    localStorage.setItem(localStorageItemKey, lang);
  }

  getLocalStorageItem() {
    return localStorage.getItem(localStorageItemKey);
  }

  // Use only with call method in order to pass this context
  changePathname(context, lang, reload) {
    const pathname = context.props.location.pathname;
    const match = context.props.match.url;
    const history = context.props.history;
    const prevLang = context.props.match.params.lang;
    const search = context.props.location.search;

    const langPath = lang === LANG_DEFAULT ? '' : `/${lang}`;
    const pathnameWithoutLang = pathname.replace(match, '') || '/';
    const splittedPathname = pathnameWithoutLang.split('/');
    const subpageAnchor =
      splittedPathname.length > 2
        ? `/${splittedPathname[1]}`
        : pathnameWithoutLang;
    const anchorObject = Object.values(ANCHOR).find(obj =>
      Object.values(obj).includes(subpageAnchor)
    );
    const replacedLangLocation =
      (pathname.replace(match, langPath) || '/') + search;
    const newLocation = anchorObject
      ? replacedLangLocation.replace(subpageAnchor, anchorObject[lang])
      : replacedLangLocation;

    const pathnameChanged =
      pathnameWithoutLang !== newLocation || prevLang !== lang;

    if (!pathnameChanged) {
      return;
    }

    if (reload) {
      window.location = newLocation;
    } else {
      history.replace(newLocation);
    }
  }

  // Use only with call method in order to pass this context
  adjustSlugToLanguage(context, item) {
    const pathname = context.props.location.pathname;
    const history = context.props.history;

    const prevSlug = context.props.match.params.slug;
    const newSlug = item && item.slug ? item.slug : prevSlug;

    const location =
      prevSlug !== newSlug ? pathname.replace(prevSlug, newSlug) : pathname;

    history.replace(location);
  }

  isActive(lang) {
    return lang === this.lang;
  }

  getSortedLanguages() {
    return LANG_AVAILABLE.sort(lang => (lang === this.getLang() ? -1 : 1));
  }
}

export default new Language();



// WEBPACK FOOTER //
// ./src/services/Language.service.js